var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('b-checkbox',{model:{value:(_vm.keep),callback:function ($$v) {_vm.keep=$$v},expression:"keep"}},[_vm._v("Garder les lignes qui correspondent aux conditions (au lieu de les supprimer)")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }